import { getContacts } from '../../api';
import { useListFetch } from '../../hooks';
import { splitSnakeCase } from '../../utilities';
import type { ContactItem, GetContactsFilters } from '../../api';

export type ItemType = ContactItem & {
  latest_contact_state_label: string;
};

const convertToItemType = (item: ContactItem): ItemType => {
  return {
    ...item,
    latest_contact_state_label: splitSnakeCase(item.latest_contact_state, {
      capitalize: true,
    }),
  };
};

export const useContacts = () => {
  return useListFetch<ItemType, GetContactsFilters>(
    async params => {
      const result = await getContacts(
        params?.filters || {},
        params?.pagination,
        params?.sortStr
      );

      return {
        content: result.items.map(convertToItemType),
        total: result.totalItems,
      };
    },
    {
      initialSort: { name: 'email', direction: 'asc' },
      initialFilters: {
        campaignId: '',
        requiresHumanInput: '',
        latest_contact_state: undefined,
      },
      withQueryParams: true,
    }
  );
};
